webpackJsonp([35783957827783],{

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _card = __webpack_require__(124);
	
	var _card2 = _interopRequireDefault(_card);
	
	__webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardGrid = function (_React$Component) {
	  _inherits(CardGrid, _React$Component);
	
	  function CardGrid() {
	    _classCallCheck(this, CardGrid);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CardGrid.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        tag = _props.tag;
	
	    var withoutHidden = data.filter(function (item) {
	      return item.slug !== "/review/hidden-reivew/";
	    });
	    withoutHidden = withoutHidden.filter(function (item) {
	      return item.slug !== "/blog/hidden-post/";
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'card-grid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card-grid__wrapper' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'card-grid__title', id: 'reviews' },
	          tag
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-grid__content' },
	          withoutHidden.map(function (item, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'card-grid__card', key: item.id + i },
	              _react2.default.createElement(_card2.default, {
	                key: item.id,
	                url: item.slug,
	                title: item.title,
	                excerpt: item.excerpt,
	                created: item.created,
	                author: item.author,
	                image: item.image
	              })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return CardGrid;
	}(_react2.default.Component);
	
	exports.default = CardGrid;
	
	
	CardGrid.propTypes = {
	  data: _propTypes2.default.array,
	  tag: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _commonStyles = __webpack_require__(105);
	
	__webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Card = function (_React$Component) {
	  _inherits(Card, _React$Component);
	
	  function Card() {
	    _classCallCheck(this, Card);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Card.prototype.render = function render() {
	    var _props = this.props,
	        url = _props.url,
	        title = _props.title,
	        excerpt = _props.excerpt,
	        image = _props.image;
	
	    var standfirst = excerpt.split(' ').slice(0, 9).join(' ');
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'card', to: url },
	      _react2.default.createElement(
	        'div',
	        { className: 'card__preview' },
	        _react2.default.createElement(
	          'figure',
	          { className: 'card__preview-image' },
	          _react2.default.createElement('div', { className: 'card__overlay', style: _commonStyles.overlayStyle }),
	          _react2.default.createElement('img', { className: 'card__image', src: image, alt: title + " image" })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'card__wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card__content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card__inner-content' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'card__title' },
	              title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card__standfirst' },
	            standfirst,
	            '...'
	          ),
	          _react2.default.createElement('div', { className: 'card__metadata-container' })
	        )
	      )
	    );
	  };
	
	  return Card;
	}(_react2.default.Component);
	
	exports.default = Card;
	
	
	Card.propTypes = {
	  url: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  excerpt: _propTypes2.default.string,
	  created: _propTypes2.default.string,
	  image: _propTypes2.default.string,
	  author: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _cardGrid = __webpack_require__(123);
	
	var _cardGrid2 = _interopRequireDefault(_cardGrid);
	
	var _jumbotron = __webpack_require__(104);
	
	var _jumbotron2 = _interopRequireDefault(_jumbotron);
	
	var _layout = __webpack_require__(22);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _structuredData = __webpack_require__(28);
	
	var _structuredData2 = _interopRequireDefault(_structuredData);
	
	var _seoTags = __webpack_require__(27);
	
	var _seoTags2 = _interopRequireDefault(_seoTags);
	
	var _utils = __webpack_require__(14);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TITLE = "Autokwix - off-road trucks Mods & Performance Parts ratings";
	var DESCRIPTION = "Autokwix.com - off-road trucks and SUVs Accessories & Performance Parts ratings. Jeep Wrangler, Dodge, Ford F150, Chevy Silverado Mods reviews and News!";
	
	var expludedFromRenderOnIndexPage = ['best-supercharger-for-jeep-jk', 'best-tacoma-lift-kit', 'best-shocks-and-struts-for-toyota-tundra', 'best-jeep-wrangler-seat-covers', 'best-jeep-wrangler-seat-covers'];
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var data = this.props.data;
	    var reviews = data.reviewsData.edges;
	
	
	    var cards = [].concat(reviews).filter(function (item) {
	      return !expludedFromRenderOnIndexPage.includes(item.node.fields.slug);
	    }).map(function (item) {
	      return {
	        id: item.node.id,
	        slug: item.node.fields.slug,
	        title: utils.updateYearToCurrent(item.node.frontmatter.title),
	        excerpt: item.node.frontmatter.introduction || item.node.excerpt,
	        created: item.node.frontmatter.created,
	        author: item.node.frontmatter.seo.author,
	        image: item.node.frontmatter.image
	      };
	    });
	
	    return _react2.default.createElement(
	      _layout2.default,
	      null,
	      _react2.default.createElement(_structuredData2.default, { isReview: false }),
	      _react2.default.createElement(_seoTags2.default, {
	        title: TITLE,
	        description: DESCRIPTION
	      }),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_jumbotron2.default, {
	          isIndexPage: true,
	          title: 'Autokwix - Tune your beast',
	          subheading: 'Start looking at reviews right now!',
	          image: '/img/jumbotron_off-road.jpg',
	          alt: 'Autokwix'
	        }),
	        _react2.default.createElement(_cardGrid2.default, { data: cards, tag: '#FEATURED' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { 'display': 'flex', 'justify-content': 'center' } },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'amazon-link amazon-link--is-black', to: '/articles/' },
	          'ALL ARTICLES'
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.shape({
	    reviewsData: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    }),
	    blogsData: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    })
	  })
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5a0a776aee408fd8fbe4.js